import React, {Fragment} from "react" ;

import { Link } from "react-router-dom";

const WieldySidebarLink = (props) =>
{
    return (
        <li className="dt-side-nav__item" key={props.keyName}>
            <Link to={props.link} className="dt-side-nav__link" title={props.title}>
                <i className={"icon " + props.iconName + " icon-fw " + props.iconSize } key={props.keyName + 'i'}/>
                <span className="dt-side-nav__text" key={props.keyName + 'span'}>{props.title}</span>
                { props.count !== 0 && <span style={{marginLeft: '40px', color: "red"}}>{props.count}</span>}
            </Link>
        </li>
    ) ;
}

export default WieldySidebarLink;
